<template>
    <div class="analysis-container">
        <!-- 左侧栏 -->
        <div class="left-sidebar ui-nav">
            <div class="ls-header">面试记录</div>
            <div class="ls-menu">
                <div class="ls-item" :class="{ active: filterMode === 'time' }" @click="switchFilterMode('time')">
                    <span class="ls-item-indicator" v-if="filterMode === 'time'"></span>
                    <img class="ls-item-icon-img" :src="timeIcon" alt="time" />
                    <span class="ls-item-text">面试时间</span>
                </div>
                <div class="ls-item" :class="{ active: filterMode === 'score' }" @click="switchFilterMode('score')">
                    <span class="ls-item-indicator" v-if="filterMode === 'score'"></span>
                    <img class="ls-item-icon-img" :src="scoreIcon" alt="score" />
                    <span class="ls-item-text">面试分数</span>
                </div>
                <div class="ls-item" :class="{ active: filterMode === 'deleted' }" @click="switchFilterMode('deleted')">
                    <span class="ls-item-indicator" v-if="filterMode === 'deleted'"></span>
                    <img class="ls-item-icon-img" :src="deleteIcon" alt="delete" />
                    <span class="ls-item-text">最近删除</span>
                </div>
            </div>
        </div>

        <!-- 中间主内容 -->
        <div class="main-content">
            <div class="recommendation-index">
                <div class="toolbar">
                    <div class="search-box">
                        <input v-model="keyword" type="text" placeholder="搜索岗位" />
                        <img class="search-icon" :src="searchIcon" alt="search" />
                    </div>
                </div>
                <div class="filters" v-if="!manageMode">
                    <template v-if="filterMode === 'time'">
                        <button class="pill" :class="{active: selectedTimeRange === 0}" @click="setTimeRange(0)">全部</button>
                        <button class="pill" :class="{active: selectedTimeRange === 3}" @click="setTimeRange(3)">3天内</button>
                        <button class="pill" :class="{active: selectedTimeRange === 7}" @click="setTimeRange(7)">一周内</button>
                        <button class="pill" :class="{active: selectedTimeRange === 30}" @click="setTimeRange(30)">一月内</button>
                        <button class="sort link">时间正序 <img class="chevron-img" :src="changeIcon" alt="chevron" /></button>
                    </template>
                    <template v-else>
                        <button class="pill" :class="{active: !selectedScoreRange}" @click="setScoreRange(null)">全部</button>
                        <button class="pill" :class="{active: selectedScoreRange && selectedScoreRange.min===90}" @click="setScoreRange({min:90,max:100})">90~100</button>
                        <button class="pill" :class="{active: selectedScoreRange && selectedScoreRange.min===75}" @click="setScoreRange({min:75,max:90})">75~90</button>
                        <button class="pill" :class="{active: selectedScoreRange && selectedScoreRange.min===60}" @click="setScoreRange({min:60,max:75})">60~75</button>
                        <button class="pill" :class="{active: selectedScoreRange && selectedScoreRange.max===60}" @click="setScoreRange({min:0,max:60})">60以下</button>
                        <button class="sort link">成绩正序 <img class="chevron-img" :src="changeIcon" alt="chevron" /></button>
                    </template>
                    <button type="button" class="link manage-link manage-link-btn" @click.stop.prevent="enterManage">记录管理</button>
                    <img class="apps-icon-img" :src="manageIcon" alt="manage" />
                </div>
                <div class="manage-bar" v-else>
                    <div class="left">
                        <button class="exit-manage" @click="exitManage">退出批量管理</button>
                        <span class="selected-count">已选中：{{ selectedIds.length }}</span>
                    </div>
                    <div class="right">
                        <label class="select-all">
                            <span class="select-all-text">全选</span>
                            <input type="checkbox" v-model="allSelected" @change="toggleSelectAll" />
                        </label>
                        <span class="delete-link" @click="deleteSelected">删除</span>
                    </div>
                </div>
            </div>

            <div class="interview-record" ref="recordScroll" @scroll="onScroll">
                <div class="record-grid" v-if="recordList && recordList.length">
                    <div class="record-card" v-for="(item, idx) in recordList" :key="idx" :class="{ selectable: manageMode, selected: selectedIds.includes(idx) }" @click="handleCardClick(idx)">
                        <div class="card-left">
                            <div class="title-line">
                                <span class="title">{{ item.title }}</span>
                                <span class="rename link" @click.stop="openRename(idx)"><img class="rename-icon" :src="renameIcon" alt="rename" />重命名</span>
                            </div>
                            <div class="meta">
                                <div class="row">
                                    <span class="tag">{{ [item.gender, item.age, item.school, item.degree, item.identity].filter(Boolean).join(' | ') }}</span>
                                </div>
                                <div class="row">
                                    <span class="chip">0-1产品经验</span>
                                    <span class="chip">B端</span>
                                    <span class="chip">团队核心</span>
                                    <span class="chip">产品专家</span>
                                </div>
                                <div class="row small">
                                    <span>面试时间：{{ item.date }}</span>
                                </div>
                                <div class="row small">
                                    <span>面试时长：{{ item.duration }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="card-right">
                            <div class="score-watermark">{{ item.overallScore != null ? item.overallScore : 0 }}</div>
                            <div class="score-watermark2">{{ item.overallScore != null ? item.overallScore : 0 }}</div>
                            <div class="mascot">
                                <img :src="scoreImg" alt="score" />
                            </div>
                            <div class="applied-count"><span class="applied-count-text">已投递岗位数：{{ item.appliedCount }}</span></div>
                        </div>
                    </div>
                </div>
                <div class="empty-state" v-else>
                    <img class="empty-img" :src="noInterviewImg" alt="暂无数据" />
                    <div class="empty-title">当前没有面试记录</div>
                    <button class="empty-primary" @click="startInterview">立即面试</button>
                </div>
            </div>
        </div>
        <div class="rename-overlay" v-if="showRename" @click.self="cancelRename">
            <div class="rename-modal">
                <div class="rename-header">面试记录重命名 <span style="cursor:pointer" @click="cancelRename">✕</span></div>
                <div class="rename-body">
                    <div class="rename-row">原有面试记录命名：<span class="rename-old">{{ renameOldTitle }}</span></div>
                    <div class="rename-row">新面试记录名称 <span style="color:#f56c6c">*</span></div>
                    <input class="rename-input" v-model="renameNewTitle" placeholder="请输入新的面试记录名称" />
                </div>
                <div class="rename-footer">
                    <button class="btn-plain" @click="cancelRename">取消</button>
                    <button class="btn-primary" @click="confirmRename">确认修改</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getUserInterviewList, deleteUserInterview, batchDeleteUserInterview, updateUserInterview,getLastDeleteInterview } from '@/api/mianshilishi.js'
export default {
    name: 'InterviewDemoTwoColumns',
    data() {
        return {
            totalScore: 95,
            summary: '请根据面试表现优化回答结构，突出亮点。',
            keyword: '',
            filterMode: 'time',
            selectedTimeRange: 0,
            selectedScoreRange: null,
            manageMode: false,
            selectedIds: [],
            allSelected: false,
            pagination: { page_no: 1, page_size: 8, count: 0 },
            isLoading: false,
            isEnd: false,
            showRename: false,
            renameIndex: null,
            renameOldTitle: '',
            renameNewTitle: '',
            recordList: [
                { title: '产品经理面试记录', gender: '男', age: '40岁', school: '香港大学', degree: '硕士', identity: '非应届', date: '2025年02月21日', duration: '30分钟', appliedCount: 2 },
                { title: '产品经理面试记录（1）', gender: '男', age: '40岁', school: '香港大学', degree: '硕士', identity: '非应届', date: '2025年02月21日', duration: '30分钟', appliedCount: 1 },
                { title: '产品经理面试记录（2）', gender: '男', age: '40岁', school: '香港大学', degree: '硕士', identity: '非应届', date: '2025年02月21日', duration: '30分钟', appliedCount: 0 },
                { title: '产品经理面试记录（3）', gender: '男', age: '40岁', school: '香港大学', degree: '硕士', identity: '非应届', date: '2025年02月21日', duration: '30分钟', appliedCount: 0 }
            ],
            scoreList: [
                { label: '沟通表达能力', value: 82 },
                { label: '问题解决与逻辑', value: 85 },
                { label: '专业能力', value: 60 },
                { label: '抗压能力', value: 70 },
                { label: '成长潜力', value: 50 }
            ],
            qaList: [
                { question: '先做一下自我介绍', answer: '我是XX，负责过XXX项目...', advice: '建议量化成果、突出核心贡献。' },
                { question: '为什么选择我们公司？', answer: '对贵司业务与文化高度认同...', advice: '增加与岗位JD的具体匹配点。' }
            ]
        };
    },
    mounted() {
        this.loadRecords(true);
    },
    computed: {
        girlImg() {
            return require('../Interview_Analysis/assets/img/Comeon.png');
        },
        scoreImg() {
            return require('../Interview_Analysis/assets/img/score.png');
        },
        noInterviewImg() {
            return require('./assets/img/noInterview.png');
        },
        timeIcon() {
            return this.filterMode === 'time'
                ? require('./assets/img/timeA.png')
                : require('./assets/img/time.png');
        },
        scoreIcon() {
            return this.filterMode === 'score'
                ? require('./assets/img/scoreA.png')
                : require('./assets/img/score.png');
        },
        deleteIcon() {
            return this.filterMode === 'deleted'
                ? require('./assets/img/deleteA.png')
                : require('./assets/img/delete.png');
        },
        changeIcon() {
            return require('./assets/img/change.png');
        },
        renameIcon() {
            return require('./assets/img/rename.png');
        },
        searchIcon() {
            return require('./assets/img/search.png');
        },
        manageIcon() {
            return require('./assets/img/manage.png');
        }
    },
    methods: {
        goToMorePosition() {
            this.$router.push('/more_position');
        },
        async loadRecords(reset) {
            try {
                if (reset) {
                    this.pagination.page_no = 1;
                    this.isEnd = false;
                    this.recordList = [];
                }
                if (this.isEnd || this.isLoading) return;
                this.isLoading = true;
                const params = {
                    page_no: this.pagination.page_no,
                    page_size: this.pagination.page_size,
                    // 将关键词作为名称或岗位进行搜索
                    interviewName: this.keyword || undefined,
                    interviewPosition: this.keyword || undefined,
                    // 时间范围（单位：天），0 表示全部
                    timeRange: this.filterMode === 'time' ? (this.selectedTimeRange || undefined) : undefined,
                    // 分数筛选（仅一个参数 overallScore，使用区间的下界表示）
                    overallScore: this.filterMode === 'score' && this.selectedScoreRange ? this.selectedScoreRange.min : undefined,
                };
                const { data } = await getUserInterviewList(params);
                if (data && data.code === 1) {
                    const list = data && data.data && Array.isArray(data.data.lists) ? data.data.lists : [];
                    this.pagination.count = data.data && data.data.count ? data.data.count : 0;
                    const nextChunk = [];
                    for (var i = 0; i < list.length; i++) {
                        var item = list[i] || {};
                        nextChunk.push({
                            title: item.interview_name || '面试记录',
                            gender: item.gender || '未知',
                            age: item.age || '未知',
                            school: item.interview_position || '未命名面试',
                            degree: item.degree || '未知',
                            identity: item.identity || '未知',
                            date: item.create_time || '',
                            duration: item.interview_time || '—',
                            appliedCount: item.job_application_count || 0,
                            overallScore: item.overall_score,
                            id: item.id
                        });
                    }
                    // 追加到现有列表
                    this.recordList = this.recordList.concat(nextChunk);
                    // 计算是否还有更多
                    const loaded = this.recordList.length;
                    if (loaded < this.pagination.count) {
                        this.pagination.page_no += 1;
                    } else {
                        this.isEnd = true;
                    }
                }
                this.isLoading = false;
            } catch (e) {
                // 保持静默，使用本地示例数据
                this.isLoading = false;
            }
        },
        async loadDeletedRecords() {
            try {
                this.isLoading = true;
                this.recordList = [];
                const { data } = await getLastDeleteInterview();
                if (data && data.code === 1) {
                    const list = data && data.data && Array.isArray(data.data) ? data.data : [];
                    const nextChunk = [];
                    for (var i = 0; i < list.length; i++) {
                        var item = list[i] || {};
                        nextChunk.push({
                            title: item.interview_name || '面试记录',
                            gender: item.gender || '未知',
                            age: item.age || '未知',
                            school: item.interview_position || '未命名面试',
                            degree: item.degree || '未知',
                            identity: item.identity || '未知',
                            date: item.create_time || '',
                            duration: item.interview_time || '—',
                            appliedCount: item.job_application_count || 0,
                            overallScore: item.overall_score,
                            id: item.id
                        });
                    }
                    this.recordList = nextChunk;
                    this.pagination.count = list.length;
                }
                this.isLoading = false;
            } catch (e) {
                // 保持静默，使用本地示例数据
                this.isLoading = false;
            }
        },
        onScroll(e) {
            const el = e.target;
            if (el.scrollTop + el.clientHeight >= el.scrollHeight - 40) {
                this.loadRecords(false);
            }
        },
        startInterview() {
            this.$router.push('/store/dashboard/profile');
        },
        switchFilterMode(mode) {
            this.filterMode = mode;
            if (mode === 'time') this.selectedTimeRange = this.selectedTimeRange || 0;
            if (mode === 'deleted') {
                this.loadDeletedRecords();
            } else {
                this.loadRecords(true);
            }
        },
        setTimeRange(val) {
            if (this.selectedTimeRange === val) return;
            this.selectedTimeRange = val;
            this.loadRecords(true);
        },
        setScoreRange(range) {
            this.selectedScoreRange = range;
            this.loadRecords(true);
        },
        enterManage() {
            this.manageMode = true;
            this.selectedIds = [];
            this.allSelected = false;
        },
        exitManage() {
            this.manageMode = false;
            this.selectedIds = [];
            this.allSelected = false;
        },
        toggleSelectAll() {
            if (this.allSelected) {
                this.selectedIds = this.recordList.map((_, idx) => idx);
            } else {
                this.selectedIds = [];
            }
        },
        toggleSelect(idx, e) {
            const checked = e.target.checked;
            const pos = this.selectedIds.indexOf(idx);
            if (checked && pos === -1) this.selectedIds.push(idx);
            if (!checked && pos !== -1) this.selectedIds.splice(pos, 1);
            this.allSelected = this.selectedIds.length === this.recordList.length;
        },
        handleCardClick(idx) {
            if (!this.manageMode) return;
            const pos = this.selectedIds.indexOf(idx);
            if (pos === -1) this.selectedIds.push(idx); else this.selectedIds.splice(pos, 1);
            this.allSelected = this.selectedIds.length === this.recordList.length;
        },
        async deleteSelected() {
            if (!this.manageMode || this.selectedIds.length === 0) return;
            try {
                // 将所选索引映射为真实 id
                const ids = this.selectedIds.map(i => this.recordList[i]?.id).filter(Boolean);
                if (ids.length === 1) {
                    await deleteUserInterview(ids[0]);
                } else if (ids.length > 1) {
                    await batchDeleteUserInterview(ids);
                }
                await this.loadRecords();
            } catch (e) {
                // 忽略错误
            } finally {
                this.selectedIds = [];
                this.allSelected = false;
            }
        },
        openRename(index) {
            this.renameIndex = index;
            this.renameOldTitle = this.recordList[index].title;
            this.renameNewTitle = this.recordList[index].title;
            this.showRename = true;
        },
        cancelRename() {
            this.showRename = false;
            this.renameIndex = null;
            this.renameNewTitle = '';
        },
        async confirmRename() {
            if (this.renameIndex === null) return;
            const newName = (this.renameNewTitle || '').trim();
            if (!newName) return;
            try {
                const id = this.recordList[this.renameIndex]?.id;
                if (id) await updateUserInterview(id, newName);
                await this.loadRecords();
            } catch (e) {
                // 忽略错误
            } finally {
                this.cancelRename();
            }
        }
    }
};
</script>

<style lang="scss" scoped>
$gradient-secondary: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
$text-primary: #656587;

.analysis-container {
    display: flex;
    height: 100vh;
    background: url('../Interview_Analysis/assets/img/_1-10.png') no-repeat center center;
    background-size: cover;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    overflow: hidden;
    align-items: center;
    justify-content: center;
    position: relative;
}

/* 固定本页文字大小，避免随 rem 缩放 */
.analysis-container,
.analysis-container * {
    font-size: 14px !important;
}

.left-sidebar {
    width: 228px;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 16px;
    margin: 20px;
    padding: 16px 12px;
    box-shadow: 0 6px 20px rgba(25, 35, 80, 0.08);
    height: 85vh;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
}

.applied-positions {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.applied-positions::-webkit-scrollbar {
    display: none;
}

/* 左侧导航（UI图）样式 */
.ui-nav .ls-header {
    font-size: 18px;
    font-weight: 700;
    color: #4c4c6d;
    padding: 6px 12px 14px 12px;
}

.ui-nav .ls-menu {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.ui-nav .ls-item {
    position: relative;
    display: flex;
    align-items: center;
    gap: 10px;
    height: 40px;
    padding: 0 12px 0 20px;
    border-radius: 12px;
    color: #656587;
}

.ui-nav .ls-item.active {
    background: linear-gradient(90deg, rgba(177, 110, 249, 0.18) 0%, rgba(126, 180, 235, 0.18) 100%);
}

.ui-nav .ls-item-indicator {
    position: absolute;
    left: 6px;
    top: 6px;
    bottom: 6px;
    width: 3px;
    border-radius: 2px;
    background: linear-gradient(180deg, #B16EF9 0%, #7EB4EB 100%);
}

.ui-nav .ls-item-icon {
    width: 18px;
    text-align: center;
    opacity: 0.9;
}

.ui-nav .ls-item-text {
    font-size: 14px;
    font-weight: 600;
}

.sidebar-header h3 {
    color: $text-primary;
    font-size: 18px;
    font-weight: 600;
    margin: 0 0 20px 0;
}

.motivation-section {
    text-align: center;
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.girl-illustration {
    margin-bottom: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.girl-image {
    max-width: 100%;
    max-height: 60%;
    object-fit: contain;
}

.motivation-text {
    margin-top: -90px;
}

.motivation-text h4 {
    background: $gradient-secondary;
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: 22px;
    font-weight: 600;
    margin: 0 0 8px 0;
}

.motivation-text p {
    color: $text-primary;
    font-size: 14px;
    margin: 4px 0;
    line-height: 1.4;
}

.apply-more-btn {
    width: 100%;
    background: $gradient-secondary;
    color: #fff;
    border: none;
    border-radius: 8px;
    padding: 12px 20px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
}

.apply-more-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(126, 180, 235, 0.3);
}

.main-content {
    flex: 0 0 1200px;
    width: 1200px;
    max-width: 1200px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    height: 85vh;
    overflow-y: auto;
}

.recommendation-index {
    background: transparent;
    padding: 8px 8px 0 8px;
}

.toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
}

.search-box {
    position: relative;
    flex: 1;
}

.search-box input {
    width: 100%;
    height: 40px;
    border-radius: 8px;
    border: 1px solid rgba(0, 0, 0, 0.06);
    background: rgba(255, 255, 255, 0.7);
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.04);
    padding: 0 36px 0 12px;
    outline: none;
}

.search-icon {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #7d6bff;
    font-size: 14px;
}

.toolbar-right {
    display: flex;
    align-items: center;
    gap: 12px;
}

.apps-icon {
    font-size: 16px;
    color: #7d6bff;
}

.filters .apps-icon {
    margin-left: 6px;
}
.apps-icon-img { width: 16px; height: 16px; margin-left: 2px; vertical-align: -2px; }

.link {
    color: #7d6bff;
    font-size: 14px;
    cursor: pointer;
}

.filters {
    display: flex;
    align-items: center;
    gap: 12px;
    padding-left: 2px;
}

.filters .manage-link {
    margin-left: auto;
}
.manage-link-btn { background: transparent; border: none; padding: 0; }

.pill {
    height: 32px;
    padding: 0 14px;
    border-radius: 8px;
    background: transparent;
    border: 1px solid rgba(125, 107, 255, 0.35);
    color: #7d6bff;
    cursor: pointer;
}

.pill.active {
    background: $gradient-secondary;
    color: #fff;
    border-color: transparent;
}

.sort {
    background: transparent;
    border: none;
}

.chevron { margin-left: 4px; }
.chevron-img { width: 12px; height: 12px; margin-left: 4px; vertical-align: -1px; }

/* 管理条 */
.manage-bar { display: flex; justify-content: space-between; align-items: center; padding: 6px 2px; }
.manage-bar .left { display: flex; align-items: center; gap: 12px; }
.exit-manage { height: 28px; padding: 0 12px; border-radius: 8px; border: none; color: #fff; background: $gradient-secondary; cursor: pointer; }
.selected-count { color: $text-primary; }
.manage-bar .right { display: flex; align-items: center; gap: 16px; }
.select-all { display: inline-flex; align-items: center; gap: 8px; }
.select-all input[type="checkbox"] {
    width: 16px;
    height: 16px;
    appearance: none;
    -webkit-appearance: none;
    outline: none;
    border: 1.5px solid transparent;
    border-radius: 4px;
    background: linear-gradient(#fff, #fff) padding-box,
                $gradient-secondary border-box;
    position: relative;
    cursor: pointer;
}
.select-all input[type="checkbox"]:checked {
    background: $gradient-secondary;
    border: none;
}
.select-all input[type="checkbox"]:checked::after {
    content: '✓';
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -58%);
    color: #fff;
    font-size: 12px;
    line-height: 1;
}
.select-all-text {
    background-image: $gradient-secondary;
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    font-weight: 600;
}
.delete-link { color: #ff5a5a; cursor: pointer; }

/* 选择态卡片效果 */
.record-card.selectable { cursor: pointer; }
/* 选中态：高亮描边、发光与轻微抬升 */
.record-card.selected {
    border-color: rgba(177,110,249,0.8);
    box-shadow: 0 6px 22px rgba(126,180,235,0.28), 0 0 0 2px rgba(177,110,249,0.6) inset;
    transform: translateY(-2px);
}

/* 空状态 */
.empty-state { min-height: 60vh; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 12px; }
.empty-img { width: 560px; max-width: 80%; height: auto; object-fit: contain; }
.empty-text { color: $text-primary; }
.empty-title { margin-top: 6px; font-weight: 700; background-image: $gradient-secondary; -webkit-background-clip: text; background-clip: text; -webkit-text-fill-color: transparent; }
.empty-primary { margin-top: 10px; width: 560px; max-width: 80%; height: 36px; border: none; border-radius: 8px; color: #fff; background: $gradient-secondary; cursor: pointer; }

/* 重命名弹窗 */
.rename-overlay { position: fixed; inset: 0; background: rgba(255,255,255,0.25); backdrop-filter: blur(8px); -webkit-backdrop-filter: blur(8px); display: flex; align-items: center; justify-content: center; z-index: 3000; }
.rename-modal { width: 560px; max-width: 92vw; border-radius: 16px; overflow: hidden; box-shadow: 0 20px 60px rgba(0,0,0,0.15); background-color: rgba(255, 255, 255, 0.15); backdrop-filter: blur(8px); -webkit-backdrop-filter: blur(8px); }
.rename-header { padding: 14px 18px; color: #fff; font-weight: 800; background: $gradient-secondary; display: flex; align-items: center; justify-content: space-between; }
.rename-body { padding: 18px; }
.rename-row { margin-bottom: 12px; color: $text-primary; }
.rename-old { background: rgba(255,255,255,0.6); border: 1px solid rgba(0,0,0,0.06); padding: 10px 12px; border-radius: 8px; }
.rename-input { width: 100%; height: 40px; border-radius: 8px; border: 1px solid rgba(0,0,0,0.08); padding: 0 12px; outline: none; background: rgba(255,255,255,0.9); }
.rename-footer { padding: 16px 18px; display: flex; gap: 12px; justify-content: space-between; }
.btn-plain { flex: 1; height: 40px; border-radius: 10px; border: 1px solid rgba(0,0,0,0.08); background: rgba(255,255,255,0.9); cursor: pointer; color: $text-primary; }
.btn-primary { flex: 1; height: 40px; border-radius: 10px; border: none; background: $gradient-secondary; color: #fff; cursor: pointer; }

.interview-record {
    padding: 24px;
    flex: 1;
    overflow-y: auto;
    -ms-overflow-style: none; /* IE/Edge */
    scrollbar-width: none; /* Firefox */
}
.interview-record::-webkit-scrollbar { display: none; }

.record-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.record-header h3 {
    color: $text-primary;
    font-size: 18px;
    font-weight: 600;
    margin: 0;
}

.export-btn {
    background: transparent;
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-image: $gradient-secondary;
    font-size: 12px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.interview-summary {
    margin-bottom: 24px;
    padding: 16px;
    background: linear-gradient(90deg, rgba(98, 175, 255, 0.1) 0%, rgba(156, 65, 255, 0.1) 100%);
    border-radius: 8px;
}

.interview-summary h4 {
    color: $text-primary;
    font-size: 16px;
    font-weight: 600;
    margin: 0 0 8px 0;
}

.interview-summary p {
    color: $text-primary;
    font-size: 14px;
    line-height: 1.6;
    margin: 0;
}

.qa-section {
    margin-bottom: 24px;
}

.question-item {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 16px;
}

.question-number {
    width: 24px;
    height: 24px;
    background: linear-gradient(90deg, rgba(98, 175, 255, 0.1) 0%, rgba(156, 65, 255, 0.1) 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #656587;
    font-size: 12px;
    font-weight: 600;
    flex-shrink: 0;
}

.question-content h5,
.answer-content h5 {
    color: #656587;
    font-size: 16px;
    font-weight: 600;
    margin: 0 0 8px 0;
}

.question-content p,
.answer-content p {
    color: #656587;
    font-size: 14px;
    line-height: 1.5;
    margin: 0;
}

.answer-content {
    margin-left: 36px;
    margin-bottom: 16px;
}

.interviewer-advice {
    background: linear-gradient(90deg, rgba(98, 175, 255, 0.1) 0%, rgba(156, 65, 255, 0.1) 100%);
    border: 1px solid rgba(98, 175, 255, 0.2);
    border-radius: 0 8px 8px 0;
    padding: 16px;
    margin-left: 22px;
    position: relative;
}

.interviewer-advice::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 8px;
    background: linear-gradient(180deg, rgba(177, 110, 249, 0.6) 0%, rgba(126, 180, 235, 0.6) 100%);
    border-radius: 0 2px 2px 0;
}

/* 面试记录卡片网格（UI图样式） */
.record-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
}

.record-card {
    --card-py: 16px;
    --card-px: 18px;
    position: relative;
    display: flex;
    justify-content: space-between;
    background: #fff;
    border-radius: 12px;
    border: 1px solid #eceff5;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
    overflow: hidden;
    padding: var(--card-py) var(--card-px);
}

/* 整体淡背景纹理 */
.record-card::after {
    content: '';
    position: absolute;
    inset: 0;
    background: url('../Interview_Analysis/assets/img/_1-10.png') center/cover no-repeat;
    opacity: 0.08;
    pointer-events: none;
    z-index: 0;
}

/* 右侧插画背景，不受内边距影响，贴边显示 */
.record-card::before {
    content: '';
    position: absolute;
    right: -12px;
    bottom: -12px;
    width: 320px;
    height: 320px;
    background: url('../Interview_Analysis/assets/img/score.png') no-repeat right bottom;
    background-size: 320px auto;
    opacity: 0.12;
    pointer-events: none;
    z-index: 0;
}

.card-left {
    position: relative;
    z-index: 1;
    width: 60%;
}

.title-line {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;
}

.title {
    font-weight: 700;
    color: #3c3c5c;
}

.rename {
    margin-left: 6px;
}
.rename-icon { width: 14px; height: 14px; margin-right: 4px; vertical-align: -2px; }

.meta .row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 8px;
    color: #656587;
}

.meta .row.small {
    opacity: 0.9;
}

.tag {
    color: #656587;
}

.chip {
    font-size: 12px !important;
    padding: 2px 8px;
    border: 1px solid transparent;
    border-radius: 6px;
    color: #6a6a8a;
    background: linear-gradient(#fff, #fff) padding-box,
                $gradient-secondary border-box;
}

.card-right {
    position: relative;
    z-index: 1;
    width: 38%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.score-watermark2 {
    z-index: 100;
    position: absolute;
    right: 140px;
    bottom: 40px;
    font-size: 70px !important;
    font-weight: 800;
    font-family: 'Afacad-Bold', sans-serif;
    pointer-events: none;
    background-image: $gradient-secondary;
    opacity: 0.2;
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
}

.score-watermark {
    z-index: 100;
    position: absolute;
    right: 60px;

    font-size: 30px !important;
    font-weight: 800;
    font-family: 'Afacad-Bold', sans-serif;
    pointer-events: none;
    background-image: $gradient-secondary;
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
}
.mascot {
    position: absolute;
    right: 10px;
    bottom: 24px;
    width: 110px;
    height: 110px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.mascot img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.applied-count {
    position: absolute;
    bottom: calc(-1 * var(--card-py));
    right: calc(-1 * var(--card-px));
    background: #ffffff;
    padding: 6px 10px;
    font-weight: 700;
    box-shadow: 0 4px 14px rgba(0,0,0,0.08);
}
.applied-count-text {
    background-image: $gradient-secondary;
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
}

/* 批量管理 + 选中时：徽标改为渐变底，文字改为白色 */
.record-card.selected .applied-count {
    background: $gradient-secondary;
    box-shadow: 0 6px 16px rgba(126, 180, 235, 0.35);
}
.record-card.selected .applied-count .applied-count-text {
    background: none;
    -webkit-text-fill-color: #fff;
    color: #fff;
}

@media (max-width: 1200px) {
    .analysis-container {
        flex-direction: column;
        height: auto;
        min-height: 100vh;
    }

    .left-sidebar {
        width: 100%;
        margin: 10px;
        height: auto;
    }

    .main-content {
        margin: 10px;
        height: auto;
    }
}

@media (max-width: 768px) {
    .analysis-container {
        height: auto;
        min-height: 100vh;
    }

    .left-sidebar,
    .main-content {
        margin: 5px;
        height: auto;
    }

    .recommendation-index,
    .interview-record {
        padding: 16px;
    }

    .index-actions {
        flex-direction: column;
        gap: 12px;
        align-items: flex-start;
    }
}
</style>
